import { type BaseTaxRateRepository } from "../../_Bases/BaseTaxRateRepository";
import { type LocalDatabaseTaxRate } from "../../_Bases/BaseTaxRateRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBTaxRateRepository extends BaseIndexedDBRepository<
    LocalDatabaseTaxRate
> implements BaseTaxRateRepository {
    public readonly source: InternalIndexedDBDatabase["taxRates"];
    protected readonly dataTypeName = "Tax Rate";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.taxRates;
    }

    public search(value: string): Promise<Array<LocalDatabaseTaxRate>> {
        const needle = value.toLowerCase();

        return this.source
            .filter(taxRate => taxRate.name.toLowerCase().includes(needle))
            .toArray();
    }
}
